document.addEventListener("turbolinks:load", function() {
  jQuery(function() {
    return $('#search_geo').autocomplete({
      source: $('#search_geo').data('autocomplete-source'),
      minLength: 3
    });
  });
});
